import React, { Component } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import Header from '../../components/Header';
import memberTable from '../../tables/members';
import memberActions from '../../actions/member';
import Table from '../../components/Table';


class Members extends Component {
  componentWillMount() {
    const { dispatch, vendor, location } = this.props;

    if (vendor.selected && vendor.selected.apikey &&
      location.selected && location.selected.apikey) {
      dispatch(memberActions.list(vendor.selected.apikey, location.selected.apikey));
    }
  }

  render() {
    return (
      <div>
				<Header
          handleLogout={this.props.handleLogoutClick}
					primaryText="NEW CAMPAIGN"
					title="MEMBERS" />
				<Table
					rows={this.props.member.data}
					columns={memberTable} />
      </div>
    );
  }
}

export default withRouter(connect(
  (state) => ({
    vendor: state.vendor,
    location: state.location,
    member: state.member
  })
)(Members));



/** WEBPACK FOOTER **
 ** ./src/containers/Members/index.js
 **/